export default (theme) => ({
	hero: {
		position: "relative",
		zIndex: 2,
		minHeight: 550,
		background: "#353535",
		width: "100%",
		[theme.breakpoints.down("xs")]: {
			height: 220,
			minHeight: "unset",
		},
	},
	picture: {
		opacity: ".7",
		position: "absolute",
		backgroundRepeat: "no-repeat",
		backgroundPosition: "center center",
		backgroundSize: "cover",
		left: 0,
		top: 0,
		right: 0,
		bottom: 0,
		transition: "all .4s",
	},
	pictureGradient: {
		background: "linear-gradient(1turn,rgba(0,0,0,.55) 25%,transparent 50%)",
	},
	backgroundImage: {
		position: "relative",
		width: "100%",
		overflow: "hidden",
		objectFit: "cover",
		objectPosition: "center center",
		display: "block",
		height: "100%",
	},
	heroH1: {
		fontSize: 44,
		lineHeight: 1.2,
		fontWeight: 700,
		marginTop: 0,
		marginBottom: 20,
		[theme.breakpoints.down("xs")]: {
			fontSize: 30,
			marginBottom: 0,
			textShadow: "2px 2px 5px #434343",
		},
	},
	heroBox: {
		position: "relative",
		padding: "40px 16px",
		[theme.breakpoints.up("md")]: {
			padding: "60px 16px",
		},
	},
	heroBoxContent: {
		padding: 64,
		backdropFilter: "blur(4px)",
		backgroundColor: "rgba(255, 255, 255, 1)",
		[theme.breakpoints.down("md")]: {
			margin: "0 auto",
		},
		[theme.breakpoints.down("xs")]: {
			boxShadow: "none",
		},
	},
	fullWrap: {
		maxWidth: 1400,
	},
	longContainer: {
		maxWidth: 800,
		[theme.breakpoints.down("md")]: {
			maxWidth: 832,
			paddingLeft: 16,
			paddingRight: 16,
		},
	},
	costH2: {
		whiteSpace: "nowrap",
	},
	costH2Unit: {
		color: theme.palette.secondary.main,
		fontWeight: 500,
		paddingLeft: 12,
		fontSize: 22,
		[theme.breakpoints.down("xs")]: {
			fontSize: 20,
			paddingLeft: 8,
		},
	},
	linearRoot: {
		backgroundColor: "#e6e6e6",
	},
	authorName: {
		fontWeight: 600,
		cursor: "pointer",
		display: "inline",
		color: "#222 !important",
	},
	authorSub: {
		color: theme.palette.grey[800],
	},
	tooltipSub: {
		fontSize: 12,
		color: theme.palette.grey[800],
	},
	body: {
		"& h1": {
			marginBottom: 40,
			marginTop: 0,
			fontSize: 48,
			lineHeight: 1.2,
			fontWeight: 700,
			[theme.breakpoints.down("xs")]: {
				fontSize: 34,
				marginTop: 24,
			},
		},
		"& h2": {
			"fontSize": 36,
			"fontWeight": 700,
			"margin": "75px 0px 24px",
			"scrollMarginTop": "100px",
			"&:first-of-type": {
				margin: "60px 0px 24px",
			},
			[theme.breakpoints.down("md")]: {
				"scrollMarginTop": "150px",
				"&:first-of-type": {
					margin: "40px 0px 24px",
				},
			},
			[theme.breakpoints.down("xs")]: {
				fontSize: 28,
				scrollMarginTop: "130px",
			},
		},
		"& h3": {
			fontSize: 26,
			fontWeight: 700,
			margin: "56px 0px 24px",
			scrollMarginTop: "100px",
			[theme.breakpoints.down("xs")]: {
				fontSize: 22,
				scrollMarginTop: "140px",
			},
		},
		"& h4": {
			fontSize: 22,
			fontWeight: 600,
			margin: "46px 0px 32px",
			[theme.breakpoints.down("xs")]: {
				fontSize: 20,
			},
		},
		"& ul": {
			marginBottom: 32,
		},
		"& ol": {
			marginBottom: 32,
		},
		"& li": {
			lineHeight: 1.6,
			fontSize: 20,
			marginBottom: 16,
			[theme.breakpoints.down("xs")]: {
				fontSize: 18,
			},
		},
		"& li li": {
			marginBottom: 8,
		},
		"& li p": {
			margin: 0,
			fontSize: "inherit",
			lineHeight: "inherit",
		},
		"& li ul": {
			marginTop: 12,
			marginBottom: 18,
		},
		"& p": {
			fontSize: 20,
			lineHeight: 1.6,
			margin: "0px 0px 32px",
			[theme.breakpoints.down("xs")]: {
				fontSize: 18,
			},
		},
		"& table": {
			width: "100%",
			display: "table",
			borderSpacing: 0,
			borderCollapse: "collapse",
		},
		"& table tr": {
			"color": "inherit",
			"display": "table-row",
			"outline": 0,
			"verticalAlign": "middle",
			"&:nth-of-type(odd)": {
				backgroundColor: "#fafafa",
			},
		},
		"& table td": {
			fontSize: "18px !important",
			display: "table-cell",
			padding: 16,
			textAlign: "left",
			fontWeight: 400,
			lineHeight: 1.43,
			borderBottom: "1px solid rgba(224, 224, 224, 1)",
			verticalAlign: "top",
			[theme.breakpoints.down("xs")]: {
				fontSize: "16px !important",
				padding: "12px 16px",
			},
		},
		"& table thead": {
			display: "table-header-group",
		},
		"& table th": {
			display: "table-cell",
			fontSize: "18px !important",
			color: "#005fb9",
			borderBottom: "2px solid rgba(224, 224, 224, 1)",
			backgroundColor: "#FFF",
			fontWeight: 600,
			lineHeight: "1.5rem",
			verticalAlign: "inherit",
			textAlign: "left",
			padding: 16,
			[theme.breakpoints.down("xs")]: {
				fontSize: "16px !important",
			},
		},
		"& table caption": {
			fontSize: "14px !important",
			color: "#222",
			padding: 16,
			textAlign: "left",
			fontWeight: 700,
			lineHeight: 1.43,
			captionSide: "top",
			borderBottom: "1px solid rgba(224, 224, 224, 1)",
		},
		"& table tbody": {
			display: "table-row-group",
		},
		"& table td ul li": {
			fontSize: "inherit !important",
			lineHeight: "inherit !important",
			marginBottom: "8px !important",
		},
		"& table td ul": {
			marginBottom: "0px !important",
		},
		"& table tfoot": {
			display: "table-footer-group",
		},
		"& table tfoot tr": {
			backgroundColor: "#f2faff !important",
		},
		"& table tfoot td": {
			color: "#000",
			fontWeight: 600,
		},
		"& table strong": {
			whiteSpace: "nowrap",
		},
		"& table p": {
			fontSize: "18px !important",
			[theme.breakpoints.down("xs")]: {
				fontSize: "16px !important",
			},
		},
		"& figure": {
			margin: "40px 0px",
		},
		"& img": {
			width: "100%",
			borderRadius: 8,
		},
		"& figcaption": {
			color: theme.palette.grey[600],
			fontSize: 14,
			paddingTop: 8,
			textAlign: "center",
		},
		"& a": {
			color: theme.palette.primary.main,
		},
		"& a:hover": {
			textDecoration: "underline",
		},
		"& strong": {
			fontWeight: 600,
		},
		"& b": {
			fontWeight: 600,
		},
		"& blockquote": {
			"lineHeight": 1.6,
			"fontSize": 18,
			"padding": 24,
			"background": "#effffa",
			"borderLeft": "5px solid #53a288",
			"margin": "0px 0px 32px",
			"borderRadius": 8,
			"fontStyle": "italic",
			"& p": {
				margin: "0 !important",
			},
		},
		"& code": {
			backgroundColor: "rgb(20 237 167 / 10%)",
			lineHeight: 1.6,
			padding: 4,
			borderRadius: 8,
		},
		"& .katex.block": {
			[theme.breakpoints.down("xs")]: {
				fontSize: "16px !important",
			},
		},
		"& .katex.inline": {
			color: "#009688",
			fontSize: "20px !important",
			[theme.breakpoints.down("xs")]: {
				fontSize: "18px !important",
			},
		},
		"& .hidden": {
			display: "none!important",
		},
		"& fieldset": {
			border: 0,
			padding: 0,
			margin: 0,
		},
		"& .btn": {
			color: "#fff",
			backgroundColor: "#222",
			borderRadius: 8,
			cursor: "pointer",
			padding: "10px 22px",
			fontWeight: 600,
			fontSize: 14,
		},
		"& .pad16": {
			padding: 16,
		},
		"& .fa-emerald": {
			color: "#50c878",
		},
	},
	summaryBox: {
		marginTop: 40,
		marginBottom: 40,
		padding: 32,
		background: "#f1f7ff",
		borderRadius: 8,
		position: "relative",
		backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='790' height='231' viewBox='0 0 790 231'%3E%3Cpath fill='%23e6f1ff' d='M0 230.5s29.344-66.776 250.736-86.799c221.392-20.022 266.778-43.673 361.278-91.49C675.014 20.335 734.344 3.098 790 .5v230H0z'/%3E%3C/svg%3E%0A")`,
		backgroundPosition: " bottom right",
		backgroundRepeat: "no-repeat",
		[theme.breakpoints.down("xs")]: {
			backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='230' viewBox='0 0 400 230'%3E%3Cpath fill='%23e6f1ff' d='M0 230s14.858-66.776 126.955-86.799c112.097-20.022 135.077-43.673 182.926-91.49C341.78 19.835 371.819 2.598 400 0v230H0z'/%3E%3C/svg%3E%0A")`,
		},
	},
	summaryTitle: {
		fontWeight: "600 !important",
		color: "#576F92 !important",
		margin: "0px 0px 20px !important",
	},
	summaryLogo: {
		position: "absolute",
		right: 16,
		bottom: 12,
	},
	alertMessage: {
		"fontSize": 18,
		"lineHeight": 1.6,
		[theme.breakpoints.down("xs")]: {
			fontSize: 16,
		},
		"& ul": {
			marginBottom: "0 !important",
		},
		"& p": {
			margin: "0 !important",
		},
	},
	promoBox: {
		userSelect: "none",
		padding: 40,
		backgroundColor: "#ceecff",
		borderRadius: 8,
		marginTop: 32,
		marginBottom: 32,
	},
	promoBoxHeader: {
		fontSize: 26,
		fontWeight: 600,
		marginBottom: 24,
		lineHeight: 1.3,
	},
	promoBoxSubHeader: {
		fontSize: 16,
		marginBottom: 24,
		lineHeight: 1.6,
	},
	promoBoxFlex: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		marginBottom: 8,
		width: "100%",
		[theme.breakpoints.down("xs")]: {
			flexDirection: "column",
		},
	},
	promoBoxFlexRight: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		marginBottom: 8,
		width: "100%",
	},
	promoBoxButtonWrap: {
		marginLeft: 16,
		width: "initial",
		[theme.breakpoints.down("xs")]: {
			marginLeft: 0,
			marginTop: 16,
			width: "100%",
		},
	},
	promoBoxButtonWrapRight: {
		marginLeft: 0,
		marginTop: 16,
		width: "100%",
	},
	promoBoxButton: {
		"height": 54,
		"color": "#FFFFFF !important",
		"&:hover": {
			textDecoration: "none !important",
		},
	},
	cardBox: {
		"position": "relative",
		"&:hover": {
			boxShadow:
				"0 0 4px 0 hsl(0deg 0% 8% / 14%), 0 16px 20px -5px hsl(0deg 0% 8% / 18%);",
			color: "#0e6be6 !important",
			transition: "all .2s ease",
		},
	},
	cardThumbnail: {
		height: 160,
	},
	cardContent: {
		padding: 24,
	},
	cardTitle: {
		fontSize: 18,
		lineHeight: 1.3,
		fontWeight: 600,
	},
	cardActions: {
		padding: 24,
	},
	cardSubText: {
		color: theme.palette.grey[600],
		fontSize: 16,
		lineHeight: 1.6,
	},
	asideBox: {
		borderRadius: "8px 8px 0px 0px",
		borderBottom: "1px solid #eee",
		backgroundColor: "#fafafa",
	},
	asideBoxHeader: {
		userSelect: "none",
		padding: "20px 24px",
		fontWeight: 600,
		fontSize: 18,
		lineHeight: 1,
	},
	asideSubHeader: {
		marginBottom: 20,
		fontSize: 18,
		lineHeight: 1.6,
		fontWeight: 700,
	},
	asideIcon: {
		minWidth: 100,
	},
	asideSubText: {
		fontSize: 16,
		lineHeight: 1.6,
		color: theme.palette.grey[800],
	},
	asideRelatedBox: {
		"overflow": "auto",
		"position": "relative",
		"maxHeight": "calc(100vh - 620px)",
		"&::-webkit-scrollbar-track": {
			backgroundColor: "#F5F5F5",
			borderRadius: 8,
		},
		"&::-webkit-scrollbar": {
			width: 6,
			backgroundColor: "#F5F5F5",
			borderRadius: 8,
		},
		"&::-webkit-scrollbar-thumb": {
			backgroundColor: "#dadada",
			borderRadius: 8,
		},
		"& ul": {
			paddingTop: 0,
			paddingBottom: 0,
		},
	},
	sideBoxDetails: {
		"& li": {
			lineHeight: 1.6,
			fontSize: 16,
			marginBottom: 8,
		},
	},
	relatedThumbnail: {
		borderRadius: 8,
		maxWidth: 90,
		marginRight: 16,
	},
	listItemText: {
		"fontWeight": 600,
		"textOverflow": "ellipsis",
		"display": "-webkit-box",
		"-webkit-line-clamp": 2,
		"-webkit-box-orient": "vertical",
		"overflow": "hidden",
	},
	TOCList: {
		"width": "100%",
		"position": "relative",
		"overflow": "auto",
		"maxHeight": "calc(100vh - 260px)",
		"padding": "0px 24px 12px 0px",
		"&::-webkit-scrollbar-track": {
			backgroundColor: "#F5F5F5",
			borderRadius: 8,
		},
		"&::-webkit-scrollbar": {
			width: 6,
			backgroundColor: "#F5F5F5",
			borderRadius: 8,
		},
		"&::-webkit-scrollbar-thumb": {
			backgroundColor: "#dadada",
			borderRadius: 8,
		},
	},
	longTOC: {
		"userSelect": "none",
		"listStyle": "none",
		"& ul": {
			marginBottom: "0 !important",
		},
		"& ul li a": {
			padding: "3px 0px !important",
			color: "#a8a8a8",
		},
		"& ol": {
			marginBottom: "0 !important",
			listStyle: "circle !important",
		},
		"& ol li a": {
			padding: "3px 0px !important",
			color: "#a8a8a8",
		},
		"& li": {
			fontSize: "16px !important",
			lineHeight: "1.4 !important",
			marginBottom: "0px !important",
			fontWeight: "600 !important",
		},
		"& li li": {
			marginBottom: "4px !important",
		},
		"& a": {
			paddingBottom: 8,
			paddingTop: 8,
			display: "block",
			color: "#6d6d6d",
		},
		"& a:hover": {
			color: "#0e6be6 !important",
		},
		"& li.active > a": {
			color: "#0e6be6 !important",
		},
		"& li.active:before": {
			content: '"\\002014"',
			fontSize: 17,
			fontWeight: 700,
			left: 12,
			marginTop: 6,
			position: "absolute",
			color: "#0e6be6",
		},
		"& ul li.active:before": {
			marginTop: "3px !important",
		},
	},

	relatedBox: {
		maxWidth: 1400,
		padding: "40px 16px",
		[theme.breakpoints.down("xs")]: {
			padding: "0px 16px 40px",
		},
	},
	costTableHead: {
		fontSize: 16,
		color: "#005fb9",
		borderBottom: "2px solid rgba(224, 224, 224, 1)",
		backgroundColor: "#FFF",
	},
	table: {
		marginTop: 40,
		marginBottom: 40,
	},
	tableBordered: {
		"& table th": {
			border: "1px solid rgba(224, 224, 224, 1) !important",
		},
		"& table td": {
			border: "1px solid rgba(224, 224, 224, 1) !important",
		},
	},
	tableFooterText: {
		color: theme.palette.grey[600],
		fontSize: "14px !important",
		paddingTop: 12,
	},
	sources: {
		"fontSize": 14,
		"& cite": {
			fontStyle: "normal",
		},
		"& li": {
			marginBottom: 20,
		},
		"& a": {
			color: theme.palette.primary.main,
		},
		"& a:hover": {
			textDecoration: "underline",
		},
	},
	iconExpanded: {
		transform: "rotate(180deg)",
		transition: "transform .15s linear,-webkit-transform .15s linear",
	},
	slideCTA: {
		boxShadow: "0 4px 12px 0 rgb(0 0 0 / 10%)",
	},
	breadcrumb: {
		fontSize: 14,
		fontWeight: 600,
		[theme.breakpoints.down("xs")]: {
			fontSize: 12,
		},
	},
	// alternative TOC like healthline
	tocUl: {
		display: "flex",
		flexWrap: "wrap",
		margin: 0,
		padding: 0,
		marginLeft: -15,
		marginBottom: 0,
		listStyle: "none",
	},
	tocItem: {
		"marginBottom": "0 !important",
		"whiteSpace": "nowrap",
		"position": "relative",
		"&:last-child:after": {
			content: "none",
		},
		"&::after": {
			top: 4,
			right: -1,
			bottom: 0,
			height: 22,
			width: 2,
			margin: "auto",
			content: '""',
			background: "#bcbfc5",
			position: "absolute",
		},
		[theme.breakpoints.down("xs")]: {
			"&::after": {
				top: 2,
				height: 16,
				width: 1,
			},
		},
	},
	tocItemA: {
		fontSize: 18,
		fontWeight: 600,
		padding: " 0 15px",
		lineHeight: 2,
		[theme.breakpoints.down("xs")]: {
			fontSize: 14,
		},
	},
	// end alternative toc
});
